import React, { useEffect, useState } from "react";
import useFooterType from "@/hooks/useFooterType";
import SidebarLogo from "../sidebar/Logo";
import MessageModal from "@/components/ui/Message-Modal";
import ReportModal from "../header/Tools/report-modal";
import Image from "next/image";
import { useAuth } from "@/contexts/authContext";
import {
  watchSentReports,
  checkSentReportsForDisabling,
} from "@/utils/helpers/helperFunctions";

const Footer = ({ className = "custom-class" }) => {
  const [footerType] = useFooterType();
  const [date, setDate] = useState();
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [showErrorModalForReportTry, setShowErrorModalForReportTry] =
    useState(false);
  const [showSuccessModalForReport, setShowSuccessModalForReport] =
    useState(false);
  const { walletAddress, isAuthenticated } = useAuth();

  // const [user, setUser] = useState(null);
  const { user } = useAuth();
  const getYear = () => setDate(new Date().getFullYear());

  useEffect(() => {
    getYear();
  }, []);

  // useEffect(() => {
  //   const handleUserHandle = async () => {

  //     if (user) {
  //       setUser(user);
  //     }
  //   };

  //   handleUserHandle();
  // }, [walletAddress]);

  const footerClassName = () => {
    switch (footerType) {
      case "sticky":
        return "sticky bottom-0 z-[999]";
      case "static":
        return "static";
      case "hidden":
        return "hidden";
    }
  };

  return (
    <footer className={className + " " + footerClassName()}>
      <div className="site-footer bg-white dark:bg-metaxseed-black text-metaxseed-gray py-12 md:py-16 px-6">
        <div className="xl:container flex flex-col items-center">
          <div className="flex flex-col md:flex-row items-center justify-center md:items-stretch md:justify-between w-full px-4">
            <div className="flex flex-col items-center md:items-start mb-12 md:mb-0">
              <div className="flex justify-start items-center w-[216px] mb-10 opacity-50 hover:opacity-100">
                <SidebarLogo zeroPadding={true} />
              </div>
              <div className="gothamBook font-normal text-xs text-metaxseed-gray cursor-default">
                Copyright &copy; {date}. All rights reserved.
              </div>
              <div className="gothamBook font-normal text-xs text-metaxseed-gray cursor-default mt-2">
                MXS Games parent company registered in Mahe, Seychelles. For
                enquiries, please email:
                <a
                  href="mailto:contact@metaxseed.io"
                  className="hover:underline"
                >
                  contact@metaxseed.io
                </a>
              </div>
            </div>
            <div className="flex flex-col flex-1 justify-center items-end">
              <div className="flex justify-between items-stretch">
                <div className="flex flex-col px-6 lg:px-12">
                  <span className="gothamMedium font-normal text-white text-xl mb-6 cursor-default">
                    Discover
                  </span>

                  <a
                    target="_blank"
                    href="https://metaxseed.gitbook.io/metaxseed-games-studio-usdxseed/"
                    className="gothamBook font-normal text-sm text-metaxseed-gray mb-2 hover:text-white"
                  >
                    Whitepaper
                  </a>
                  <a
                    target="_blank"
                    href="https://metaxseed.gitbook.io/metaxseed-games-studio-usdxseed/roadmap"
                    className="gothamBook font-normal text-sm text-metaxseed-gray mb-2 hover:text-white"
                  >
                    Roadmap
                  </a>
                </div>
                <div className="flex flex-col px-6 lg:px-12">
                  <span className="gothamMedium font-normal text-white text-xl mb-6 cursor-default">
                    Resources
                  </span>

                  {/* <a target="_blank" href="https://docs.google.com/presentation/d/1YbB7oSqm6DzAdiGqk3ptUGDfe1HUzyAxaXalfRo0mN8/edit#slide=id.g247fbb6ffd9_0_0" className="gothamBook font-normal text-sm text-metaxseed-gray mb-2 hover:text-white">Node Deck</a> */}
                  <a target="_blank" href="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/audit_reports%2FMXS_Games_Ferrum_Hacken_24122021_Upgradable%20Token.pdf?alt=media&token=770c44ab-16cb-4914-8534-2c6bb95865bb" className="gothamBook font-normal text-sm text-metaxseed-gray mb-2 hover:text-white">Hacken Audit</a>
                  <a
                    target="_blank"
                    href="https://medium.com/metaxseed-games/mxs-gold-reward-system-explained-31e1fe3351b3"
                    className="gothamBook font-normal text-sm text-metaxseed-gray mb-2 hover:text-white"
                  >
                    Reward System
                  </a>
                </div>
                <div className="flex flex-col px-6 lg:px-12">
                  <span className="gothamMedium font-normal text-white text-xl mb-6 cursor-default">
                    Support
                  </span>

                  <a
                    target="_blank"
                    href="https://medium.com/metaxseed-games/metaxseed-games-faqs-f219b43ad085"
                    className="gothamBook font-normal text-sm text-metaxseed-gray mb-2 hover:text-white"
                  >
                    FAQ
                  </a>
                  <a
                    onClick={(e) => {
                      if (!user || !isAuthenticated) {
                        window.open(
                          "https://forms.gle/QEcczpQwyxupKN3Y8",
                          "_blank"
                        );
                      } else {
                        e.preventDefault();

                        if (checkSentReportsForDisabling()) {
                          setIsReportModalOpen(true);
                        } else {
                          setShowErrorModalForReportTry(true);
                        }
                      }
                    }}
                    className="gothamBook font-normal text-sm text-metaxseed-gray mb-2 hover:text-white cursor-pointer"
                  >
                    Report Issue
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {showSuccessModalForReport && (
          <MessageModal
            title={`Thank you!`}
            fireworks={false}
            status={true}
            centered
            activeModal={showSuccessModalForReport}
            onClose={() => {
              setShowSuccessModalForReport(false);
            }}
          >
            <div className="flex items-center">
              <Image
                src={
                  "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fgeneral_media%2F0c72afb44d6ff7f0e7280d050c078407_w200.webp?alt=media&token=6edb828c-a3a5-482d-8ca1-4bdcb1f734ec"
                }
                width={200}
                height={200}
                alt=""
                className="mb-4 max-h-[100px] xl:max-h-[200px] !max-w-fit mx-auto"
                unoptimized
              />
            </div>
            <div className="gothamBook text-metaxseed-text-gray py-2 text-center">
              Thanks for participating and helping us maintain the quality of
              our service. Your report has been successfully submitted.
            </div>
          </MessageModal>
        )}

        {showErrorModalForReportTry && (
          <MessageModal
            title={`Limit Exceeded!`}
            fireworks={false}
            status={false}
            centered
            activeModal={showErrorModalForReportTry}
            onClose={(e) => {
              if (e) {
                setShowErrorModalForReportTry(false);
              }
            }}
          >
            <div className="flex items-center">
              <Image
                src={
                  "https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/website%2Fgeneral_media%2F2iFb.gif?alt=media&token=e94a95a8-710f-4f13-84a3-eeb821318379"
                }
                width={200}
                height={200}
                alt=""
                className="mb-4 max-h-[100px] xl:max-h-[200px] !max-w-fit mx-auto"
              />
            </div>
            <div className="gothamBook text-metaxseed-text-gray py-2 text-center">
              We&apos;re sorry, but you've reached the maximum limit for report
              submissions within one hour. Please try again later.
            </div>
          </MessageModal>
        )}

        {isReportModalOpen && (
          <ReportModal
            user={user}
            isOpen={isReportModalOpen}
            onClose={(e) => {
              if (typeof e === "object") {
                setIsReportModalOpen(false);
              } else if (e) {
                setIsReportModalOpen(false);
                setShowSuccessModalForReport(true);
                watchSentReports(user);
              }
            }}
          />
        )}
      </div>
    </footer>
  );
};

export default Footer;
